export default "__VITE_ASSET__C1VI62uY__"